import angular from 'angular';
import './app.module';
import { lazyLoadModule } from './core/helpers/lazy-load.helper';

function configureStates($stateProvider, $urlRouterProvider) {
  $urlRouterProvider.otherwise('/dashboard');

  $stateProvider
    .state('auth', {
      abstract: true,
      component: 'cpAuthLayout'
    })
    .state('auth.login', {
      url: '/login',
      component: 'cpLogin'
    })
    .state('auth.reset-password', {
      url: '/redefinir-senha?empresa&token',
      component: 'cpResetPassword'
    })
    .state('auth.privacy', {
      url: '/privacidade',
      component: 'cpPrivacyPolicy'
    })
    .state('app', {
      abstract: true,
      component: 'cpMainLayout'
    })
    .state({
      name: 'app.dashboard.**',
      url: '/dashboard',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "dashboard" */ './modules/dashboard/index.js')
      )
    })
    .state({
      name: 'app.connectors.**',
      url: '/connectors',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "connectors" */ './modules/connectors/index.js')
      )
    })
    .state({
      name: 'app.conversations.**',
      url: '/conversas',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "conversations" */ './modules/conversations/index.js')
      )
    })
    .state({
      name: 'app.contacts.**',
      url: '/contatos',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "contacts" */ './modules/contacts/index.js')
      )
    })
    .state({
      name: 'app.crm.**',
      url: '/crm',
      lazyLoad: lazyLoadModule(() => import(/* webpackChunkName: "crm" */ './modules/crm/index.js'))
    })
    .state({
      name: 'app.sales.**',
      url: '/vendas',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "sales" */ './modules/sales/index.js')
      )
    })
    .state({
      name: 'app.products.**',
      url: '/produtos',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "products" */ './modules/products/index.js')
      )
    })
    .state({
      name: 'app.support.**',
      url: '/suporte',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "support" */ './modules/support/index.js')
      )
    })
    .state({
      name: 'app.chatbots.**',
      url: '/chatbots',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "chatbots" */ './modules/chatbots/index.js')
      )
    })
    .state({
      name: 'app.ai-agents.**',
      url: '/agentes-ia',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "ai-agents" */ './modules/ai-agents/index.js')
      )
    })
    .state({
      name: 'app.payments.**',
      url: '/pagamentos',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "payments" */ './modules/payments/index.js')
      )
    })
    .state({
      name: 'app.automation.**',
      url: '/automacoes',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "automation" */ './modules/automation/index.js')
      )
    })
    .state({
      name: 'app.campaigns.**',
      url: '/campanhas',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "campaigns" */ './modules/campaigns/index.js')
      )
    })
    .state({
      name: 'app.templates.**',
      url: '/templates',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "templates" */ './modules/templates/index.js')
      )
    })
    .state({
      name: 'app.quick-replies.**',
      url: '/respostas-rapidas',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "quick-replies" */ './modules/quick-replies/index.js')
      )
    })
    .state({
      name: 'app.teams.**',
      url: '/equipes',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "teams" */ './modules/teams/index.js')
      )
    })
    .state({
      name: 'app.permissions.**',
      url: '/permissoes',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "permissions" */ './modules/permissions/index.js')
      )
    })
    .state({
      name: 'app.numbers.**',
      url: '/numeros',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "numbers" */ './modules/numbers/index.js')
      )
    })
    .state({
      name: 'app.integrations.**',
      url: '/integracoes',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "integrations" */ './modules/integrations/index.js')
      )
    })
    .state({
      name: 'app.reports.**',
      url: '/relatorios',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "reports" */ './modules/reports/index.js')
      )
    })
    .state({
      name: 'app.analytics.**',
      url: '/analytics',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "analytics" */ './modules/analytics/index.js')
      )
    })
    .state({
      name: 'app.settings.**',
      url: '/configuracoes',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "settings" */ './modules/settings/index.js')
      )
    })
    .state({
      name: 'app.reminders.**',
      url: '/lembretes',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "reminders" */ './modules/reminders/index.js')
      )
    })
    .state({
      name: 'app.admin-members.**',
      url: '/membros-administracao',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "admin-members" */ './modules/admin-members/index.js')
      )
    })
    .state({
      name: 'app.calendar.**',
      url: '/agenda',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "calendar" */ './modules/calendar/index.js')
      )
    })
    .state({
      name: 'app.notifications.**',
      url: '/notificacoes',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "notifications" */ './modules/notifications/index.js')
      )
    })
    .state({
      name: 'app.audit.**',
      url: '/auditoria',
      lazyLoad: lazyLoadModule(
        () => import(/* webpackChunkName: "audit" */ './modules/audit/index.js')
      )
    });
}

configureStates.$inject = ['$stateProvider', '$urlRouterProvider'];

angular.module('app').config(configureStates);
